import {
    StyledEngineProvider,
    ThemeProvider,
    createTheme,
} from "@mui/material/styles";
import shadows, { createCustomShadows } from "./shadows";

import { CssBaseline } from "@mui/material";
import PropTypes from "prop-types";
import { createPalette } from "./palette";
import { isDev } from "../utils/isDev";
import { isMerry } from "../utils/isMerry";
import { isSpooky } from "../utils/isSpooky";
import { overrideComponentsStyle } from "./overrides";
import typography from "./typography";
import { useDynamicTheme } from "../hooks/useDynamicTheme";
import { useMemo } from "react";

const buildTheme = (flags) => {
    const palette = createPalette(flags);
    return createTheme({
        palette,
        shape: { borderRadius: 8 },
        typography,
        shadows,
        customShadows: createCustomShadows(palette),
        components: overrideComponentsStyle,
        custom: flags,
    });
};

export const ThemeConfig = ({ children }) => {
    const { dynamicThemeEnabled } = useDynamicTheme();
    const spooky = dynamicThemeEnabled && isSpooky();
    const merry = dynamicThemeEnabled && isMerry();

    const theme = useMemo(
        () => buildTheme({ isDev: isDev(), isSpooky: spooky, isMerry: merry }),
        [spooky, merry]
    );

    return (
        <StyledEngineProvider injectFirst>
            <ThemeProvider theme={theme}>
                <CssBaseline />
                {children}
            </ThemeProvider>
        </StyledEngineProvider>
    );
};

ThemeConfig.propTypes = {
    children: PropTypes.node,
};
